import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';

@Directive({
  selector: '[notMatch]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotMatchDirective, multi: true }]
})
export class NotMatchDirective implements Validator {
  @Input('notMatch') notMatch: string[] = [];

  validate(formGroup: FormGroup): ValidationErrors {
    return this.check(this.notMatch[0], this.notMatch[1])(formGroup);
  }

  check(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      // return null if controls haven't initialised yet
      if (!control || !matchingControl) {
        return null;
      }

      // return null if another validator has already found an error on the matchingControl
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (control.value === matchingControl.value) {
        matchingControl.setErrors({ notMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }
}